import { useEffect, useState } from "react";
import { Typography, Tabs, Tab, Tooltip, Button } from "@mui/material";
import { tss } from "tss-react";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "components";
import ApiUtils from "api/Utils";
import * as Utils from "services/UtilsService";
import pkg from "../../package.json";
import AuthService from "services/AuthService";
import commonStyles, { panelBackgroundColor } from "styles/common";
import viewsStyles from "styles/views";

const useStyles = tss.create({
    root: {
        paddingLeft: 45,
        paddingTop: 35,
    },
    table: {
        width: "100%",
    },
    row: {
        borderBottom: "1px solid rgba(0,0,0,0.1)",
        height: 35,
    },
    firstCol: {
        width: 170,
    },
    section: {
        padding: 4,
        marginLeft: 15,
        marginTop: 10,
    },
});

type StateConfig = {
    platform_version: string;
    capacity: string[];
    stop: string[];
    started: string[];
    running: string[];
    processing: string[];
    done: string[];
    unclear: string[];
    last_change: string;
};

const initialState: StateConfig = {
    platform_version: "N/A",
    capacity: [],
    stop: [],
    started: [],
    running: [],
    processing: [],
    done: [],
    unclear: [],
    last_change: "",
};

export default function Settings() {
    const { classes: common } = commonStyles();
    const { classes: viewsClasses } = viewsStyles();
    const { classes, cx } = useStyles();
    const { mode } = useParams();
    const [tab, setTab] = useState(0);
    const [values, setValues] = useState<StateConfig>(initialState);

    useEffect(() => {
        ApiUtils.getPlatformVersion((result: any) => {
            let ascale: Array<any> = result?.autoScale?.AutoScale;
            let newVal: StateConfig;
            if (ascale?.length > 0) {
                newVal = {
                    platform_version: result?.platform_version,
                    capacity: ascale.map((e) => e.name),
                    stop: getResume(ascale, 0),
                    started: getResume(ascale, 1),
                    running: getResume(ascale, 2),
                    processing: getResume(ascale, 3),
                    done: getResume(ascale, 4),
                    unclear: getResume(ascale, 5),
                    last_change: new Date(result?.autoScale?.Time).toString(),
                };
            } else {
                newVal = initialState;
                newVal.platform_version = result?.platform_version;
            }

            setValues(newVal);
        });
    }, []);

    const getResume = (list: Array<any>, val: number) => {
        let result: string[] = [];
        list.forEach((e) => {
            if (e?.State === val) {
                result.push(e.name);
            }
        });
        return result;
    };

    const handleChange = (e: any, newTab: number) => {
        setTab(newTab);
    };

    const copyAuthToken = () => {
        Utils.copyContent(AuthService.getToken(), (result: string) => {});
    };
    return (
        <div className={viewsClasses.root}>
            <div className={cx(common.middle, viewsClasses.topHeader)}>
                <BreadCrumbs label="Settings" />
            </div>
            <div className={viewsClasses.content}>
                <div
                    style={{
                        paddingLeft: 20,
                        paddingBottom: 20,
                        //backgroundColor: panelBackgroundColor,
                        height: "fit-content",
                        width: "100%",
                    }}
                >
                    <Tabs
                        value={tab}
                        onChange={handleChange}
                        aria-label="Settings"
                        indicatorColor="primary"
                        style={{ marginTop: 20, width: "max-content" }}
                        className={common.tabs}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#D97D54",
                                color: "#D97D54",
                            },
                        }}
                    >
                        <Tab label="About" value={0} />
                        <Tab label="Processing Nodes" value={1} />
                        {mode === "developer" ? <Tab label="Developer" value={2} /> : ""}
                    </Tabs>
                    {tab === 0 && (
                        <table className={classes.table} cellSpacing={0} cellPadding={0} style={{ paddingTop: 15 }}>
                            <tbody>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Typography className={common.mediumLabel}>Version</Typography>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Typography className={common.mediumLabel}>{pkg.version}</Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Typography className={common.mediumLabel}>Spatial Platform</Typography>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Typography className={common.mediumLabel}>
                                            {values ? values.platform_version : "N/A"}
                                        </Typography>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    {tab === 1 && (
                        <table className={classes.table} cellSpacing={0} cellPadding={0} style={{ paddingTop: 15 }}>
                            <tbody>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Typography className={common.mediumLabel}>Last Update</Typography>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Typography className={common.mediumLabel}>{values?.last_change}</Typography>
                                    </td>
                                </tr>

                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Tooltip title={values.capacity.join(", ")}>
                                            <Typography className={common.mediumLabel}>Capacity</Typography>
                                        </Tooltip>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Tooltip title={values.capacity.join(", ")}>
                                            <Typography className={common.mediumLabel}>
                                                {values?.capacity.length}
                                            </Typography>
                                        </Tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Tooltip title={values.stop.join(", ")}>
                                            <Typography className={common.mediumLabel}>Stopped</Typography>
                                        </Tooltip>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Tooltip title={values.stop.join(", ")}>
                                            <Typography className={common.mediumLabel}>
                                                {values?.stop.length}
                                            </Typography>
                                        </Tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Tooltip title={values.processing.join(", ")}>
                                            <Typography className={common.mediumLabel}>Processing</Typography>
                                        </Tooltip>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Tooltip title={values.processing.join(", ")}>
                                            <Typography className={common.mediumLabel}>
                                                {values?.processing.length}
                                            </Typography>
                                        </Tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Tooltip title={values.done.join(", ")}>
                                            <Typography className={common.mediumLabel}>Idle</Typography>
                                        </Tooltip>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Tooltip title={values.done.join(", ")}>
                                            <Typography className={common.mediumLabel}>
                                                {values?.done.length}
                                            </Typography>
                                        </Tooltip>
                                    </td>
                                </tr>

                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Tooltip title={values.started.join(", ")}>
                                            <Typography className={common.mediumLabel}>Starting</Typography>
                                        </Tooltip>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Tooltip title={values.started.join(", ")}>
                                            <Typography className={common.mediumLabel}>
                                                {values?.started.length}
                                            </Typography>
                                        </Tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Tooltip title={values.running.join(", ")}>
                                            <Typography className={common.mediumLabel}>Waiting</Typography>
                                        </Tooltip>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Tooltip title={values.running.join(", ")}>
                                            <Typography className={common.mediumLabel}>
                                                {values?.running.length}
                                            </Typography>
                                        </Tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={cx(classes.row, classes.firstCol)} style={{ border: 0 }}>
                                        <Tooltip title={values.unclear.join(", ")}>
                                            <Typography className={common.mediumLabel}>Unknown</Typography>
                                        </Tooltip>
                                    </td>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Tooltip title={values.unclear.join(", ")}>
                                            <Typography className={common.mediumLabel}>
                                                {values?.unclear.length}
                                            </Typography>
                                        </Tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    {tab === 2 && (
                        <table className={classes.table} cellSpacing={0} cellPadding={0} style={{ paddingTop: 15 }}>
                            <tbody>
                                <tr>
                                    <td className={classes.row} style={{ border: 0 }}>
                                        <Button color="primary" onClick={copyAuthToken}>
                                            Copy Authorization Token
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
